<loader *ngIf="saving"></loader>

<cat-entries
  [selectMode]="true"
  (onPhrasesSelected)="onPhrasesSelected($event)"
></cat-entries>
